// extracted by mini-css-extract-plugin
export var body = "Content-module--body--3LJXt";
export var content = "Content-module--content--3dNJJ";
export var title = "Content-module--title--3vQh6";